import { createFileRoute } from "@tanstack/react-router";
import { GroupPage } from "@corpuscomplete/web/modules/auth/group/pages/group";
import { GroupDetail } from "@corpuscomplete/core-ui/auth/group/detail";

export const Route = createFileRoute("/_authenticated/groups/$id/")({
  component: GroupPage,
  loader: async ({ context, params }) => {
    if (context.zero) {
      GroupDetail.preload(context.zero, params.id);
    }
  },
});
